const C = 240;
const R = 165;
const LABELS = ["People", "Responsibilities", "Technology", "Knowledge", "Authority", "Intelligence"];
const NODES = LABELS.map((label, i) => {
  const a = ((-90 + i * 60) * Math.PI) / 180;
  return { label, x: C + R * Math.cos(a), y: C + R * Math.sin(a) };
});
const anchorFor = (x) => (x > C + 5 ? "start" : x < C - 5 ? "end" : "middle");
const dxFor = (x) => (x > C + 5 ? 12 : x < C - 5 ? -12 : 0);
const dyFor = (y) => (y < C - 100 ? -14 : y > C + 100 ? 22 : 4);

export const HeroStructure = () => (
  <figure className="relative m-0" data-testid="hero-structure">
    <svg viewBox="-40 0 560 480" className="h-auto w-full" role="img" aria-label="Provisional diagram: six elements arranged around human purposes">
      {[60, 130, 200].map((s) => (
        <rect key={s} x={C - s} y={C - s} width={s * 2} height={s * 2} fill="none" stroke="var(--o-line-strong)" strokeWidth="1" />
      ))}
      <polygon points={NODES.map((n) => `${n.x},${n.y}`).join(" ")} fill="none" stroke="var(--o-line-strong)" strokeDasharray="3 5" />
      {NODES.map((n) => (
        <line key={`l-${n.label}`} x1={n.x} y1={n.y} x2={C} y2={C} stroke="var(--o-line)" />
      ))}
      <rect x={C - 60} y={C - 60} width="120" height="120" fill="var(--o-bg)" stroke="var(--o-accent)" />
      <text x={C} y={C - 4} textAnchor="middle" fill="var(--o-text)" fontFamily="IBM Plex Mono" fontSize="11" letterSpacing="2.5">HUMAN</text>
      <text x={C} y={C + 14} textAnchor="middle" fill="var(--o-text)" fontFamily="IBM Plex Mono" fontSize="11" letterSpacing="2.5">PURPOSES</text>
      {NODES.map((n) => (
        <g key={n.label}>
          <circle cx={n.x} cy={n.y} r="5" fill="var(--o-bg)" stroke="var(--o-accent)" strokeWidth="1.5" />
          <text x={n.x + dxFor(n.x)} y={n.y + dyFor(n.y)} textAnchor={anchorFor(n.x)} fill="var(--o-dim)" fontFamily="IBM Plex Mono" fontSize="11" letterSpacing="1.2">
            {n.label.toUpperCase()}
          </text>
        </g>
      ))}
    </svg>
    <figcaption className="mt-2 flex items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.18em] text-o-dim">
      <span>Human Structure · arrangements around human purposes</span>
      <span className="draft-tag">Provisional element</span>
    </figcaption>
  </figure>
);
